import React from 'react';

const Blog = () => {
    return (
        <div className='mt-5 pt-5'>
            <h2>Coming Soon...</h2>
        </div>
    );
};

export default Blog;